import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { CampaignToolsCustomDonationAmountsSettings } from 'assets/js/pages/campaign-settings/campaign-tools/CampaignToolsCustomDonationAmountsSettings';
import { CampaignToolsCustomFields } from 'assets/js/pages/campaign-settings/campaign-tools/CampaignToolsCustomFields';
import { CampaignToolsFundSettings } from 'assets/js/pages/campaign-settings/campaign-tools/CampaignToolsFundSettings';
import { CampaignToolsMatchSettings } from 'assets/js/pages/campaign-settings/campaign-tools/CampaignToolsMatchSettings';
import { CampaignToolsPaymentSettings } from 'assets/js/pages/campaign-settings/campaign-tools/CampaignToolsPaymentSettings';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';

const CampaignTools = () => {
    const { data: campaign } = useCurrentCampaign();

    const hasCampaignMatchOption = ['page', 'event'].includes(campaign?.type_friendly ?? '');

    return (
        <Box className={'flex flex-col gap-8 p-8'}>
            <CampaignToolsPaymentSettings />
            <Separator />
            <CampaignToolsCustomDonationAmountsSettings />
            <Separator />
            <CampaignToolsFundSettings />
            <Separator />
            {hasCampaignMatchOption && (
                <>
                    <CampaignToolsMatchSettings />
                    <Separator />
                </>
            )}
            <CampaignToolsCustomFields />
        </Box>
    );
};

export default CampaignTools;
